import { makeContextModule } from '@cian/react-utils';

import { IPublicDesktopV2OffersGetOffersResponse } from 'shared/repositories/commercial-search-offers/desktop/v2/offers/get-offers';

export const {
  Context: { Provider: ListingContextProvider, Consumer: ListingContextConsumer },
  useContext: useListingContext,
  withContext: withListingContext,
} = makeContextModule<IPublicDesktopV2OffersGetOffersResponse>({
  contextName: 'ListingContext',
});
